import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';
import { IconColorDirective } from '../icon/directives/icon-color.directive';
import { IconComponent } from '../icon/icon.component';
import { BadgeColor } from './badge.types';

@Component({
  selector: 'rt-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'color',
  },
  standalone: true,
  imports: [NgIf, IconColorDirective, IconComponent],
})
export class BadgeComponent {
  @Input() public color: BadgeColor;
  @Input() public iconName: IconName;
  @Input() public text: string | number;
}
